/* =========================================================
   Prostavive — interactive bits
   ========================================================= */
(function(){
  // package selector
  var pkgs = document.querySelectorAll('.pv-pkg__opt');
  pkgs.forEach(function(el){
    el.addEventListener('click', function(){
      pkgs.forEach(function(o){ o.classList.remove('is-active'); });
      el.classList.add('is-active');
      // sync sticky bar price
      var name = el.querySelector('.pv-pkg__qty')?.textContent || '';
      var price = el.querySelector('.pv-pkg__price')?.textContent || '';
      var strike = el.querySelector('.pv-pkg__strike')?.textContent || '';
      var stickName = document.querySelector('[data-pv-stick-name]');
      var stickPrice = document.querySelector('[data-pv-stick-price]');
      if (stickName) stickName.textContent = 'Prostavive — ' + name;
      if (stickPrice) stickPrice.innerHTML = '<s>' + strike + '</s> <b>' + price + '</b> <span>· 70% off ends today</span>';
    });
  });

  // hero gallery thumb switching (cosmetic — swaps active border)
// Hero gallery thumb switching
document.addEventListener('DOMContentLoaded', function () {

  // Select all carousels separately
  const carousels = document.querySelectorAll('.pv-hero__media');

  carousels.forEach(function (gallery, galleryIndex) {

    const slides = gallery.querySelectorAll('.pv-gallery__slide');
    const thumbs = gallery.querySelectorAll('.pv-gallery__thumb');
    const prevBtn = gallery.querySelector('.pv-gallery__arrow--prev');
    const nextBtn = gallery.querySelector('.pv-gallery__arrow--next');

    if (!slides.length) return;

    let current = 0;

    // Show first slide initially
    updateSlider(0);

    function updateSlider(index) {

      slides.forEach(function (slide) {
        slide.classList.remove('active');
      });

      thumbs.forEach(function (thumb) {
        thumb.classList.remove('is-active');
      });

      if (slides[index]) {
        slides[index].classList.add('active');
      }

      if (thumbs[index]) {
        thumbs[index].classList.add('is-active');
      }

      current = index;
    }

    // Thumbnail click
    thumbs.forEach(function (thumb, index) {

      thumb.addEventListener('click', function () {
        updateSlider(index);
      });

    });

    // Next button
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {

        current++;

        if (current >= slides.length) {
          current = 0;
        }

        updateSlider(current);

      });
    }

    // Prev button
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {

        current--;

        if (current < 0) {
          current = slides.length - 1;
        }

        updateSlider(current);

      });
    }

  });

});

  // sticky ATC reveal after scrolling past hero
  var stick = document.querySelector('.pv-stick');
  var hero = document.querySelector('.pv-hero');
  if (stick && hero) {
    var onScroll = function(){
      var heroBottom = hero.getBoundingClientRect().bottom;
      var nearFooter = false;
      var foot = document.querySelector('.pv-foot');
      if (foot) {
        nearFooter = foot.getBoundingClientRect().top < window.innerHeight - 80;
      }
      if (heroBottom < 0 && !nearFooter) stick.classList.add('is-visible');
      else stick.classList.remove('is-visible');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();

// toggle mobile menu

document.addEventListener('DOMContentLoaded', function(){ 
   const nav = document.querySelector('.pv-nav');  
   const toggle = document.querySelector('.pv-menu-toggle');  
   if(!nav || !toggle) return;  
   toggle.addEventListener('click', function(){    
    nav.classList.toggle('menu-open');  });});


// cart drawer script

document.addEventListener('DOMContentLoaded', function () {

  const cartBtn = document.querySelector('.js-cart-toggle');

  if (!cartBtn) return;

  cartBtn.addEventListener('click', function (e) {

    e.preventDefault();

    // DAWN
    const dawnDrawer = document.querySelector('cart-drawer');

    if (dawnDrawer) {

      // Dawn method
      if (typeof dawnDrawer.open === 'function') {
        dawnDrawer.open(cartBtn);
        return;
      }

      // fallback class
      dawnDrawer.classList.add('active');

      const overlay = dawnDrawer.querySelector('.drawer__overlay');

      if (overlay) {
        overlay.classList.remove('hidden');
      }

      return;
    }

    // HORIZON / MODAL
    const dialogDrawer =
      document.querySelector('cart-drawer-component dialog') ||
      document.querySelector('dialog');

    if (dialogDrawer) {

      if (typeof dialogDrawer.showModal === 'function') {
        dialogDrawer.showModal();
        return;
      }

    }

    // DETAILS DRAWER
    const detailsDrawer =
      document.querySelector('details[id*="Cart"]') ||
      document.querySelector('details.cart-drawer');

    if (detailsDrawer) {
      detailsDrawer.setAttribute('open', 'open');
      return;
    }

    // CLICK FALLBACK
    const fallbackTrigger =
      document.querySelector('.header__icon--cart') ||
      document.querySelector('[data-cart-toggle]') ||
      document.querySelector('[href="#CartDrawer"]');

    if (fallbackTrigger) {
      fallbackTrigger.click();
      return;
    }

    // FINAL FALLBACK
    window.location.href = '/cart';

  });

});


// scroll to section

document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('.scroll-to-section').forEach(btn => {
    btn.addEventListener('click', function (e) {

      e.preventDefault();

      e.stopPropagation();

      const target = document.querySelector(this.dataset.target);

      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }

    });
  });

});


// accordion attribute remove

document.addEventListener('DOMContentLoaded', function () {
  const details = document.querySelectorAll('details');

  function handleDetails() {
    if (window.innerWidth <= 767) {
      details.forEach(item => {
        item.removeAttribute('open');
      });
    }
  }

  handleDetails();

  window.addEventListener('resize', handleDetails);
});





// one-time and subscription Switch normal landing page

document.addEventListener('DOMContentLoaded', function() {

  (function() {

    'use strict';
 
    // ============================================

    // CONFIG: Links + Pricing per variant

    // ============================================

    const VARIANT_CONFIG = {

      // Subscribe & Save

      '44446359027805': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44446359027805:1;8155591934045:44527245230173:1;8155590754397:44527242707037:1&cur=USD', save: 40,  total: 59,  strike: 99  },

      '44446359060573': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44446359060573:1;8155591934045:44527245230173:1;8155590754397:44527242707037:1&cur=USD', save: 179, total: 118, strike: 297 },

      '44446359093341': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44446359093341:1;8155591934045:44527245230173:1;8155590754397:44527242707037:1&cur=USD', save: 318, total: 177, strike: 495 },

      // One-Time

      '44427051827293': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44427051827293:1;8155591934045:44527245230173:1;8155590754397:44527242707037:1&cur=USD', save: 30,  total: 69,  strike: 99  },

      '44427051860061': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44427051860061:1;8155591934045:44527245230173:1;8155590754397:44527242707037:1&cur=USD', save: 159, total: 138, strike: 297 },

      '44427051892829': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44427051892829:1;8155591934045:44527245230173:1;8155590754397:44527242707037:1&cur=USD', save: 288, total: 207, strike: 495 }

    };
 
    // ============================================

    // DEFAULT SELECTION ON TOGGLE SWITCH

    // Change this to 1 or 5 if you ever want a different default pack

    // ============================================

    const DEFAULT_BOTTLE_ON_SWITCH = 5;
 
    // ============================================

    // STATE

    // ============================================

    const state = {

      mode: 'subscribe',

      selectedBottle: DEFAULT_BOTTLE_ON_SWITCH

    };
 
    // ============================================

    // DOM

    // ============================================

    const root = document.getElementById('purchase-block');

    if (!root) return;
 
    const toggleBtns   = root.querySelectorAll('.pv-toggle-btn');

    const pkgGroups    = root.querySelectorAll('.pv-pkg');

    const totalEl      = root.querySelector('.pv-pkg_total');

    const strikeEl     = root.querySelector('.pv-pkg__strike');

    const saveEl       = root.querySelector('.pv-pkg_save');

    const variantInput = document.getElementById('pv-variant-id');

    const form         = document.getElementById('pv-product-form');
    
    const paymentCancel = document.querySelector('.payment_cancel');
 

    // ============================================

    // HELPERS

    // ============================================

    const fmt = (n) => Number.isInteger(n) ? `$${n}` : `$${n.toFixed(2)}`;

    const getActiveGroup = () => root.querySelector(`.pv-pkg[data-group="${state.mode}"]`);
 
    // ============================================

    // CORE UPDATE

    // ============================================

    function update() {

      toggleBtns.forEach(btn => {

        btn.classList.toggle('active', btn.dataset.type === state.mode);

      });
 
      pkgGroups.forEach(group => {

        group.classList.toggle('active', group.dataset.group === state.mode);

      });
 
      const activeGroup = getActiveGroup();

      if (!activeGroup) return;
 
      const options = activeGroup.querySelectorAll('.pv-pkg__opt');

      let targetOpt = activeGroup.querySelector(`.pv-pkg__opt[data-bottle-number="${state.selectedBottle}"]`);

      if (!targetOpt) targetOpt = options[0];
 
      options.forEach(opt => opt.classList.remove('is-active'));

      targetOpt.classList.add('is-active');
 
      const variantId = targetOpt.dataset.variantId;

      const config = VARIANT_CONFIG[variantId];

      if (!config) return;
 
      if (variantInput) variantInput.value = variantId;

      if (totalEl)  totalEl.textContent  = fmt(config.total);

      if (strikeEl) strikeEl.textContent = fmt(config.strike);

      if (saveEl)   saveEl.textContent   = fmt(config.save);
 
      form.dataset.checkoutUrl = config.link;

      if (state.mode === 'subscribe') {
       paymentCancel.classList.add('show_payment-cancel');
       } else {
       paymentCancel.classList.remove('show_payment-cancel');
       }

    }
 
    // ============================================

    // EVENTS

    // ============================================

    toggleBtns.forEach(btn => {

      btn.addEventListener('click', (e) => {

        e.preventDefault();

        const newMode = btn.dataset.type;

        if (newMode === state.mode) return;

        state.mode = newMode;

        // Reset to default pack whenever the user switches mode

        state.selectedBottle = DEFAULT_BOTTLE_ON_SWITCH;

        update();

      });

    });
 
    root.addEventListener('click', (e) => {

      const opt = e.target.closest('.pv-pkg__opt');

      if (!opt) return;

      if (!opt.closest('.pv-pkg.active')) return;
 
      const bottleNum = parseInt(opt.dataset.bottleNumber, 10);

      if (!bottleNum || bottleNum === state.selectedBottle) return;
 
      state.selectedBottle = bottleNum;

      update();

    });
 
    form.addEventListener('submit', (e) => {

      e.preventDefault();

      const url = form.dataset.checkoutUrl;

      if (url) window.location.href = url;

    });
 
    update();
 
  })();

});

// one-time and subscription Switch normal gem page

document.addEventListener('DOMContentLoaded', function() {
  (function() {
    'use strict';
 
    // ============================================
    // CONFIG: Links + Pricing per variant
    // ============================================
    const VARIANT_CONFIG = {
      // Subscribe & Save
      '44446359027805': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44446359027805:1;8155591934045:44527245230173:1;8155590754397:44527242707037:1&cur=USD', save: 40,  total: 59,  strike: 99  },
      '44446359060573': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44446359060573:1;8155591934045:44527245230173:1;8155590754397:44527242707037:1&cur=USD', save: 179, total: 118, strike: 297 },
      '44446359093341': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44446359093341:1;8155591934045:44527245230173:1;8155590754397:44527242707037:1&cur=USD', save: 318, total: 177, strike: 495 },
      // One-Time
      '44427051827293': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44427051827293:1;8155591934045:44527245230173:1;8155590754397:44527242707037:1&cur=USD', save: 30,  total: 69,  strike: 99  },
      '44427051860061': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44427051860061:1;8155591934045:44527245230173:1;8155590754397:44527242707037:1&cur=USD', save: 159, total: 138, strike: 297 },
      '44427051892829': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44427051892829:1;8155591934045:44527245230173:1;8155590754397:44527242707037:1&cur=USD', save: 288, total: 207, strike: 495 }
    };
 
    // ============================================
    // DEFAULT SELECTION ON TOGGLE SWITCH
    // ============================================
    const DEFAULT_BOTTLE_ON_SWITCH = 5;
 
    // ============================================
    // STATE
    // ============================================
    const state = {
      mode: 'subscribe',
      selectedBottle: DEFAULT_BOTTLE_ON_SWITCH
    };
 
    // ============================================
    // DOM
    // ============================================
    const root = document.getElementById('purchase-block');
    if (!root) return;
 
    const toggleBtns  = root.querySelectorAll('.pv-toggle-btn');
    const pkgGroups   = root.querySelectorAll('.pv-pkg');
    const totalEl     = root.querySelector('.pv-pkg_total');
    const strikeEl    = root.querySelector('.pv-pkg__strike');
    const saveEl      = root.querySelector('.pv-pkg_save');
    const checkoutBtn = root.querySelector('.direct-to-checkout-btn');
    const paymentCancel = root.querySelector('.payment_cancel');
 
    // ============================================
    // HELPERS
    // ============================================
    const fmt = (n) => Number.isInteger(n) ? `$${n}` : `$${n.toFixed(2)}`;
    const getActiveGroup = () => root.querySelector(`.pv-pkg[data-group="${state.mode}"]`);
 
    // ============================================
    // CORE UPDATE
    // ============================================
    function update() {
      toggleBtns.forEach(btn => {
        btn.classList.toggle('active', btn.dataset.type === state.mode);
      });
 
      pkgGroups.forEach(group => {
        group.classList.toggle('active', group.dataset.group === state.mode);
      });
 
      const activeGroup = getActiveGroup();
      if (!activeGroup) return;
 
      const options = activeGroup.querySelectorAll('.pv-pkg__opt');
      let targetOpt = activeGroup.querySelector(`.pv-pkg__opt[data-bottle-number="${state.selectedBottle}"]`);
      if (!targetOpt) targetOpt = options[0];
 
      options.forEach(opt => opt.classList.remove('is-active'));
      targetOpt.classList.add('is-active');
 
      const variantId = targetOpt.dataset.variantId;
      const config = VARIANT_CONFIG[variantId];
      if (!config) return;
 
      if (totalEl)  totalEl.textContent  = fmt(config.total);
      if (strikeEl) strikeEl.textContent = fmt(config.strike);
      if (saveEl)   saveEl.textContent   = fmt(config.save);
 
      if (checkoutBtn) checkoutBtn.dataset.checkoutUrl = config.link;

      if (state.mode === 'subscribe') {
       paymentCancel.classList.add('show_payment-cancel');
       } else {
       paymentCancel.classList.remove('show_payment-cancel');
       }
    }
 
    // ============================================
    // EVENTS
    // ============================================
    toggleBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const newMode = btn.dataset.type;
        if (newMode === state.mode) return;
        state.mode = newMode;
        state.selectedBottle = DEFAULT_BOTTLE_ON_SWITCH;
        update();
      });
    });
 
    root.addEventListener('click', (e) => {
      const opt = e.target.closest('.pv-pkg__opt');
      if (!opt) return;
      if (!opt.closest('.pv-pkg.active')) return;
 
      const bottleNum = parseInt(opt.dataset.bottleNumber, 10);
      if (!bottleNum || bottleNum === state.selectedBottle) return;
 
      state.selectedBottle = bottleNum;
      update();
    });
 
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const url = checkoutBtn.dataset.checkoutUrl;
        if (url) window.location.href = url;
      });
    }
 
    update();
 
  })();
});

// one-time and subscription Switch normal gem page free product

document.addEventListener('DOMContentLoaded', function() {
  (function() {
    'use strict';
 
    // ============================================
    // CONFIG: Links + Pricing per variant
    // ============================================
    const VARIANT_CONFIG = {
      // Subscribe & Save
      '44446359027805': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44446359027805:1;8147962298461:44501206335581:1;8147966754909:44501166948445:1&cur=USD', save: 40,  total: 59,  strike: 99  },
      '44446359060573': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44446359060573:1;8147962298461:44501206335581:1;8147966754909:44501166948445:1&cur=USD', save: 179, total: 118, strike: 297 },
      '44446359093341': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44446359093341:1;8147962298461:44501206335581:1;8147966754909:44501166948445:1&cur=USD', save: 318, total: 177, strike: 495 },
      // One-Time
      '44427051827293': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44427051827293:1;8147962298461:44501206335581:1;8147966754909:44501166948445:1&cur=USD', save: 30,  total: 69,  strike: 99  },
      '44427051860061': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44427051860061:1;8147962298461:44501206335581:1;8147966754909:44501166948445:1&cur=USD', save: 159, total: 138, strike: 297 },
      '44427051892829': { link: 'https://secure.tryprostavive.co/?products=8130511765597:44427051892829:1;8147962298461:44501206335581:1;8147966754909:44501166948445:1&cur=USD', save: 288, total: 207, strike: 495 }
    };
 
    // ============================================
    // DEFAULT SELECTION ON TOGGLE SWITCH
    // ============================================
    const DEFAULT_BOTTLE_ON_SWITCH = 5;
 
    // ============================================
    // STATE
    // ============================================
    const state = {
      mode: 'subscribe',
      selectedBottle: DEFAULT_BOTTLE_ON_SWITCH
    };
 
    // ============================================
    // DOM
    // ============================================
    const root = document.getElementById('purchase-block');
    if (!root) return;
 
    const toggleBtns  = root.querySelectorAll('.pv-toggle-btn');
    const pkgGroups   = root.querySelectorAll('.pv-pkg');
    const totalEl     = root.querySelector('.pv-pkg_total');
    const strikeEl    = root.querySelector('.pv-pkg__strike');
    const saveEl      = root.querySelector('.pv-pkg_save');
    const checkoutBtn = root.querySelector('.direct-to-checkout-btn-test');
    const paymentCancel = root.querySelector('.payment_cancel');
 
    // ============================================
    // HELPERS
    // ============================================
    const fmt = (n) => Number.isInteger(n) ? `$${n}` : `$${n.toFixed(2)}`;
    const getActiveGroup = () => root.querySelector(`.pv-pkg[data-group="${state.mode}"]`);
 
    // ============================================
    // CORE UPDATE
    // ============================================
    function update() {
      toggleBtns.forEach(btn => {
        btn.classList.toggle('active', btn.dataset.type === state.mode);
      });
 
      pkgGroups.forEach(group => {
        group.classList.toggle('active', group.dataset.group === state.mode);
      });
 
      const activeGroup = getActiveGroup();
      if (!activeGroup) return;
 
      const options = activeGroup.querySelectorAll('.pv-pkg__opt');
      let targetOpt = activeGroup.querySelector(`.pv-pkg__opt[data-bottle-number="${state.selectedBottle}"]`);
      if (!targetOpt) targetOpt = options[0];
 
      options.forEach(opt => opt.classList.remove('is-active'));
      targetOpt.classList.add('is-active');
 
      const variantId = targetOpt.dataset.variantId;
      const config = VARIANT_CONFIG[variantId];
      if (!config) return;
 
      if (totalEl)  totalEl.textContent  = fmt(config.total);
      if (strikeEl) strikeEl.textContent = fmt(config.strike);
      if (saveEl)   saveEl.textContent   = fmt(config.save);
 
      if (checkoutBtn) checkoutBtn.dataset.checkoutUrl = config.link;

      if (state.mode === 'subscribe') {
       paymentCancel.classList.add('show_payment-cancel');
       } else {
       paymentCancel.classList.remove('show_payment-cancel');
       }
    }
 
    // ============================================
    // EVENTS
    // ============================================
    toggleBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const newMode = btn.dataset.type;
        if (newMode === state.mode) return;
        state.mode = newMode;
        state.selectedBottle = DEFAULT_BOTTLE_ON_SWITCH;
        update();
      });
    });
 
    root.addEventListener('click', (e) => {
      const opt = e.target.closest('.pv-pkg__opt');
      if (!opt) return;
      if (!opt.closest('.pv-pkg.active')) return;
 
      const bottleNum = parseInt(opt.dataset.bottleNumber, 10);
      if (!bottleNum || bottleNum === state.selectedBottle) return;
 
      state.selectedBottle = bottleNum;
      update();
    });
 
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const url = checkoutBtn.dataset.checkoutUrl;
        if (url) window.location.href = url;
      });
    }
 
    update();
 
  })();
});
 



